import { useEffect, useState } from "react";
import { ExternalLink, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminConsultations() {
  const [data, setData] = useState(null);

  useEffect(() => {
    document.title = "Consultations | Rooted Healing Admin";
    api.get("/admin/consultations").then(({ data }) => setData(data));
  }, []);

  if (!data) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="h-7 w-7 animate-spin text-forest" />
      </div>
    );
  }

  return (
    <div data-testid="admin-consultations">
      <h1 className="font-serif text-3xl text-forest">Consultations</h1>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-taupe">
        Booking runs through Staci's external scheduler. This site records link clicks only.
      </p>

      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
        {[data.options.terrain, data.options.full].map((c) => (
          <div key={c.cta} className="rounded-[1.75rem] border border-forest/10 bg-white/75 p-7">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-gold-dark">
              {c.minutes} minutes{c.iridology ? " · with iridology" : ""}
            </p>
            <p className="mt-3 text-sm leading-relaxed text-charcoal/75">{c.cta}</p>
            <p className="mt-3 font-serif text-2xl text-forest">${c.price_usd}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-[1.75rem] border border-forest/10 bg-white/75 p-7">
        <h2 className="font-serif text-xl text-forest">Booking activity</h2>
        <p className="mt-3 text-sm text-charcoal/75">
          Scheduler link clicks recorded: <strong>{data.clicks_total}</strong>
        </p>
        {Object.keys(data.clicks_by_location).length > 0 && (
          <ul className="mt-3 flex flex-col gap-1.5 text-sm text-charcoal/70">
            {Object.entries(data.clicks_by_location).map(([loc, n]) => (
              <li key={loc}>
                <span className="font-semibold text-forest">{loc}</span>: {n}
              </li>
            ))}
          </ul>
        )}
        <a
          data-testid="consultations-open-scheduler"
          href={data.booking_url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 inline-flex items-center gap-2 rounded-full bg-forest px-6 py-3 text-sm font-semibold text-ivory hover:bg-forest-deep"
        >
          <ExternalLink className="h-4 w-4" />
          Open the scheduler
        </a>
        <p className="mt-3 text-xs text-taupe">
          Current booking link: {data.booking_url} · Change it anytime under Website Content
          ("Consultation booking link"). It updates every Book button, report, and email
          automatically.
        </p>
      </div>

      <div className="mt-6 rounded-[1.75rem] border border-gold/30 bg-sage/50 p-7">
        <h2 className="font-serif text-xl text-forest">Integration limitation</h2>
        <p className="mt-3 text-sm leading-relaxed text-charcoal/75">{data.limitation}</p>
        <p className="mt-3 text-sm leading-relaxed text-charcoal/75">
          Configuration for a future deeper connection lives on the Integrations page.
        </p>
      </div>
    </div>
  );
}
